import { render } from "./FarmFilter.vue?vue&type=template&id=6079bd26"
import script from "./FarmFilter.vue?vue&type=script&lang=js"
export * from "./FarmFilter.vue?vue&type=script&lang=js"

import "./FarmFilter.vue?vue&type=style&index=0&id=6079bd26&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__